const INITIAL_STATE = {
    configuracaoReservaVoucher: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'CONFIGURACAO_RESERVA_VOUCHER_FETCHED':
        return { ...state, configuracaoReservaVoucher: action.payload }
      default:
        return state
    }
  }